import { render, staticRenderFns } from "./SensorOverviewList.vue?vue&type=template&id=90f4f2f2"
import script from "./SensorOverviewList.vue?vue&type=script&lang=js"
export * from "./SensorOverviewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports